import {
    BackButton,
    convertFromBoolean,
    convertToBoolean,
    Divider,
    Form,
    FormDropDown,
    FormRadio,
    Header,
    setAttributeEntity,
    useAlignments,
    useSizes,
} from 'metrix-common3';
import React from 'react';
import { FormattedMessage } from 'react-intl';

const ProfileDwellingSwimmingPool = (props) => {
    const sizes = useSizes();
    const alignments = useAlignments();

    return (
        <React.Fragment>
            <BackButton clickEvent={props.backEvent} />
            <Divider top={sizes.md} />
            <Header
                size={sizes.md}
                textAlign={alignments.left}
                text={<FormattedMessage id='Profile_Dwellings_SwimmingPool.swimmingPool' />}
            />
            <Form
                label={<FormattedMessage id='Profile_Dwellings_SwimmingPool.swimmingPoolDetails' />}
                allowEdit={props.allowEdit}
                saveEvent={() => props.doUpsertPolicy()}
                cancelEvent={() => props.doGetPolicy()}
            >
                <FormDropDown
                    label={<FormattedMessage id='Profile_Dwellings_SwimmingPool.type' />}
                    value={props.swimmingPool?.type}
                    references={props.reference.references?.PoolType}
                    referencesEvent={() => props.reference.doGetReferences('PoolType')}
                    changeEvent={(value) =>
                        setAttributeEntity(`${props.dotProp}type`, value, props.doReducePolicyElement)
                    }
                    allowEdit
                />
                <FormDropDown
                    label={<FormattedMessage id='Profile_Dwellings_SwimmingPool.construction' />}
                    value={props.swimmingPool?.constructionType}
                    references={props.reference.references?.PoolConstructionType}
                    referencesEvent={() => props.reference.doGetReferences('PoolConstructionType')}
                    changeEvent={(value) =>
                        setAttributeEntity(`${props.dotProp}constructionType`, value, props.doReducePolicyElement)
                    }
                    allowEdit
                />
                <FormDropDown
                    label={<FormattedMessage id='Profile_Dwellings_SwimmingPool.condition' />}
                    value={props.swimmingPool?.condition}
                    references={props.reference.references?.PoolCondition}
                    referencesEvent={() => props.reference.doGetReferences('PoolCondition')}
                    changeEvent={(value) =>
                        setAttributeEntity(`${props.dotProp}condition`, value, props.doReducePolicyElement)
                    }
                    allowEdit
                />
                <FormRadio
                    label={<FormattedMessage id='Profile_Dwellings_SwimmingPool.approvedFence' />}
                    value={props.swimmingPool && { code: convertFromBoolean(props.swimmingPool.approvedFence) }}
                    references={props.reference.references?.YesNo}
                    referencesEvent={() => props.reference.doGetReferences('YesNo')}
                    changeEvent={(value) =>
                        props.doReducePolicyElement({
                            code: `${props.dotProp}approvedFence`,
                            value: convertToBoolean(value.code),
                        })
                    }
                    allowEdit
                />
            </Form>
        </React.Fragment>
    );
};

export default ProfileDwellingSwimmingPool;
